import { Box, Breadcrumbs, Fab, Link, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Table } from '../../../../interface/components/table';
import { MdiIcon } from '@components';
import { mdiPlus } from '@mdi/js';
import { useModal } from 'mui-modal-provider';
import DialogResultado from './dialog';
const ListResultados = ({ $state, ListaResultadoService, UIService }) => {
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const { showModal } = useModal();
    const [data, setData] = useState();
    const [departamentos, setDepartamentos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams());
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    /*
    const onCellView = (cell: ICoreListaRelatorioResultado) => {
      $state.go('app.administration.resultados.view', { id: cell.id });
    };
    */
    const initialFetch = async () => {
        if (loading) {
            const opt = await ListaResultadoService.options();
            const dpt = await ListaResultadoService.departamentos();
            setOptions(opt);
            setDepartamentos(dpt);
            setLoading(false);
        }
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await ListaResultadoService.findAll({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            setData(aux);
        }
        catch (e) { }
        setRefetching(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Typography variant='h5'>Listagem</Typography>
        <Breadcrumbs aria-label='breadcrumb'>
          {/* <Link underline='none' color='inherit'>
          Administração
        </Link> */}
          <Link underline='none' color='inherit'>
            Listas e relatórios
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            Resultados
          </Link>
        </Breadcrumbs>
      </Box>

      <Box>
        <Table storageKey={$state.current.name} data={data} columns={[
            {
                accessorKey: 'id',
                header: '#',
                size: 50
            },
            {
                accessorKey: 'coreDepartamentoId',
                header: 'Departamento',
                size: 75,
                filterSelectOptions: departamentos.map(r => {
                    return {
                        value: r.id,
                        label: r.designacao
                    };
                }),
                Cell: ({ row }) => {
                    return row.original.Departamento?.designacao;
                }
            },
            {
                accessorKey: 'designacao',
                header: 'Designação'
            }
        ]} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort}/>
      </Box>
      {!loading && (<Box sx={{
                position: 'fixed',
                margin: 2,
                bottom: 0,
                right: 0,
                display: 'flex',
                gap: 1
            }}>
          {!loading && (<Tooltip title={'Adicionar novo'}>
              <Fab color={'error'} onClick={() => {
                    showModal(DialogResultado, {
                        departamentos: departamentos,
                        onClose: (data) => {
                            if (data) {
                                ListaResultadoService.create({
                                    id: 0,
                                    designacao: data.designacao,
                                    coreDepartamentoId: data.coreDepartamentoId,
                                    active: 1,
                                    valor: 0,
                                    default: 0
                                })
                                    .then(() => {
                                    UIService.addToast('Adicionado novo tipo de defeito/cláusula');
                                    fetchData();
                                })
                                    .catch(e => {
                                    UIService.addToast('Ocorreu um erro ao adicionar o tipo de defeito/cláusula');
                                });
                            }
                        }
                    });
                }}>
                <MdiIcon path={mdiPlus}/>
              </Fab>
            </Tooltip>)}
        </Box>)}
    </Box>);
};
export default ListResultados;
